import React, { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

import classNames from 'classnames';

import '../css/TopNavTabLabel.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import { getCssUrlArgument, getStyleVar } from '../utils/style';

/**
 * TopNavTabLabel
 *
 * Wrap a given top nav tab label (`children`) and conditionally prepend an
 * icon when the CSS variable (`--icon-${activeTopNavName}-${tabId}`)
 * resolves to a URL (e.g. `--icon-StudentTopNav-assignmentTiles`).
 *
 * If `iconUrl` is undefined, return the label as-is; otherwise return the
 * label with the icon preceding it.
 */
const TopNavTabLabel = (props) => {
  const { isSelected, topNavTabObj, children } = props;
  const { topNavManager } = useContext(MobXProviderContext);

  const activeTopNavName = props.activeTopNavName || topNavManager?.activeTopNavName;
  const tabId = topNavTabObj?._id;

  if (!activeTopNavName || !tabId) {
    return children;
  }

  const iconStyleVar = isSelected ? (
    `--icon-${activeTopNavName}-${tabId}-selected`
  ) : (
    `--icon-${activeTopNavName}-${tabId}`
  );
  const iconUrl = getCssUrlArgument(getStyleVar(iconStyleVar));

  if (!iconUrl) {
    return children;
  }

  return (
    <>
      <div
        aria-hidden='true'
        className={classNames('top-nav-tab-label-icon', activeTopNavName, tabId)}
        style={{ backgroundImage: `url(${iconUrl})` }} />
      {children}
    </>
  );
};

export default TopNavTabLabel;
SatCoreRegister('TopNavTabLabel', TopNavTabLabel);
